import React, {Fragment} from "react";
import PropTypes from "prop-types";
import imageMuurKlampVisible from "../../../images/situation/maten/muur/Yzichtbaar.jpg";
import imageMuurKlamp from "../../../images/situation/maten/muur/Ynietzichtbaar.jpg";
import imageKozijnKlampVisible from "../../../images/situation/maten/kozijn/Yzichtbaar.jpg";
import imageKozijnKlamp from "../../../images/situation/maten/kozijn/Ynietzichtbaar.jpg";

export default function MaatY(props) {
    let image;
    if (props.isMuurMontage) {
        switch (props.klampen) {
            case "visible":
                image = imageMuurKlampVisible;
                break;
            default:
                image = imageMuurKlamp;
                break;
        }
    } else {
        switch (props.klampen) {
            case "visible":
                image = imageKozijnKlampVisible;
                break;
            default:
                image = imageKozijnKlamp;
                break;
        }
    }
    return <Fragment>
        <div className="addtextMore">
            Vul hier de dikte van de klampen in, in milimeters.
        </div>
        <img className="explainImage" src={image} alt=""/>
    </Fragment>;
}

MaatY.propTypes = {
    isMuurMontage: PropTypes.bool.isRequired,
    klampen: PropTypes.oneOf("none", "visible", "invisible").isRequired,
}